/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Content/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import * as fromHelpers from './helpers.js'
import React from 'react'
import TysiaText from 'DesignSystem/TysiaText/index'



/** @type {import('Simple/types.js').View} */
export default function Content({
  children,
  viewPath = "/DesignSystem/ManualAutomations/Content/Content/ActiveAction/CheckRequirements/Requirements/Requirement/Skipped/Content/Content"
  
}) {
let requirementValueData = fromData.useDataValue({ viewPath,
context: 'requirement',
})
let taskBasketTitleValueData = fromData.useDataValue({ viewPath,
context: 'task_basket',
path: 'title',
})
let aggregateData = fromHelpers.getDescription(requirementValueData, taskBasketTitleValueData)
let dtColorsNeutral700 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.700'
        })
let dtSpaceXs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xs'
        })
  return (<React.Fragment
>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 data="requirement"
 data="task_basket.title"
 aggregate="helpers.js getDescription"
 text={aggregateData}
 size="xmedium"
 color={dtColorsNeutral700}
 marginTop={dtSpaceXs}
/>
{children}
</React.Fragment>)
}